import request from '@/utils/request.js'

//注册
/**
 *
 * @param {手机号码} mobile
 * @param {昵称} nickname
 * @param {验证码} code
 * @param {密码} pass
 * @param {来源域名} referrer
 * @param {继续教育机构id} jxjy_org_id
 */
export function register(mobile, nickname, code, pass, referrer, jxjy_org_id,openid,type) {
    return request({
        url: '/public/register',
        method: 'POST',
        params: {
            phone: mobile,
            nickname: nickname,
            code: code,
            pass: pass,
            jxjy_org_id: jxjy_org_id,
            openid:openid,
            type:type
        }
    })
}

export function register2(data) {
    return request({
        url: '/public/register',
        method: 'POST',
        data
    })
}

//忘记密码
export function forgetPwd(mobile, code, pass) {
    return request({
        url: '/public/pass',
        method: 'PUT',
        params: {phone: mobile, code: code, pass: pass}
    })
}

//登录
export function login(mobile, pass) {
    return request({
        url: '/auth/login',
        method: 'POST',
        params: {phone: mobile, pass: pass}
    })
}

//刷新token
export function refreshToken() {
    return request({
        url: '/auth/refresh-token',
        method: 'PUT',
        params: {phone: mobile, pass: pass}
    })
}


//发送注册短信验证码
export function smgRegCode(mobile) {
    return request({
        url: '/public/sms-code',
        method: 'POST',
        params: {phone: mobile, type: 1}
    })
}


//发送找回密码短信验证码
export function smgForgetCode(mobile) {
    return request({
        url: '/public/sms-code',
        method: 'POST',
        params: {phone: mobile, type: 2}
    })
}


//微信扫码登录：已绑定账号时返回token，未绑定账号返回open_id,下一步跳转去关联已有账号
export function weiXinLogin() {
    return request({
        url: '/oauth/wechat/login',
        method: 'POST'
    })
}

//帐号和第三方登录授权绑定
export function connectAuth(data) {
    return request({
        url: '/auth/connect-oauth',
        method: 'POST',
        data
    })
}

export function sendSms(data) {
    return request({
        url: '/public/sms-code',
        method: 'POST',
        data
    })
}
